
jQuery(document).ready(function($){

  function get_parameters_by_object(url){
      var search = url.search.substring(1);
      return JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) });
  }

  function add_parameter_as_suffix_to_links(){
    if(window.location.search != "") {
      var params = get_parameters_by_object(window.location);
      var region = params.o;
      var links = $('div:not(.wpProQuiz_content) a');
      links.each(function(){
        var href = $(this).attr('href');
        var isLink = (href) ? href.indexOf("http") : false;
        isLink = (isLink >=0 ) ? true : false;
        var hasRegion= (href) ? href.indexOf("o=") : false;
        hasRegion = (hasRegion >=0 ) ? true : false;
        var hasQuiz= (href) ? href.indexOf("/certificates/") : false;
        hasQuiz = (hasQuiz >=0 ) ? true : false;
        var hasLog = (href) ? href.indexOf("log") : false;
        hasLog = (hasLog >=0 ) ? true : false;
        var isInternal = (href) ? href.indexOf(window.location.origin) : false;
        isInternal = (isInternal >=0 ) ? true : false;
        var isWordpress = (href) ? href.indexOf("wp-admin") : false;
        isWordpress = (isWordpress >=0 ) ? true : false;
        isWordpress = !!isWordpress;
        var linkHasParameter = (href) ? href.indexOf("?") : false;
        linkHasParameter = (linkHasParameter >=0 ) ? true : false;

        // add to internal links parameter to region
        if(isLink  && !hasRegion  && isInternal && !isWordpress && !hasQuiz && !hasLog) {
          if(linkHasParameter) {
            $(this).attr('href', href + '&o='+region);
          } else {
            $(this).attr('href', href + '?o='+region);
          }
        }
      });
    }
  }
  add_parameter_as_suffix_to_links();
  
  // prevent default on dropdown area click
  $('.top-menu > a').click(function(e){
    e.preventDefault();
  })

  // make contact icon absolute/fixed
  if($(".kb-contact-button.kb-modal-trigger").length > 0) {
    function placeContactIcon() {
      const scrollY = $(window).scrollTop();
      const windowHeight = $(window).innerHeight();
      let footerOffsetTop = $("#site-footer").offset().top - windowHeight;

      if(window.innerWidth > 600) {
        if(scrollY > footerOffsetTop) {
          $(".kb-contact-button.kb-modal-trigger ").removeClass("fixed");
        } else {
          $(".kb-contact-button.kb-modal-trigger").addClass("fixed");
        }
      }
    }
    placeContactIcon();
    
    $(window).scroll(function() {
      placeContactIcon();
    })
    $(window).resize(function() {
      if(window.innerWidth <= 600) {
        $(".kb-contact-button.kb-modal-trigger ").removeClass("fixed");
      }
    })
  }
});
